import { BaseApi } from "../../../services/base-api";
import { INDS_StoreFrontId } from "../constant/constant";
import { ReportsRequestPayload } from "../model/contact-admin-model";
import { ENDPOINTS } from "./endpoint";
export interface ReportItem {
  reportId: number;
  reportName: string;
  reportDescription: string;
  storeId: number;
}
export const getViewReports = async (roleId?: number): Promise<ReportItem[]> => {
  const payload: ReportsRequestPayload = { storeId: INDS_StoreFrontId, ...(roleId !== undefined ? { roleId } : {}) };
  try {
    const response = await BaseApi.baseApiCon.post(ENDPOINTS.reports.viewReports, payload);
    return response.data.data.reports;
  } catch (error: any) {
    throw new Error(error?.response?.data?.errorMessage || error?.response?.data?.errorDescription );
  }
};
export const generateReports = async (payload: any): Promise<any> => {
  try {
    const response = await BaseApi.baseApiCon.post(ENDPOINTS.reports.generateReports, payload);
    return response.data.data;
  } catch (error: any) {
    throw new Error(error?.response?.data?.errorMessage || error?.response?.data?.errorDescription );
  }
};